export default __webpack_public_path__ + "static/media/type_11_9.7dc62ef9.svg";